"use client";

import Link from "next/link";
import styles from "./ArticleMeta.module.css";
import { useEffect, useState } from "react";
import { getUrlLang } from "@/utils/common";

function stripHtml(html: string): string {
  return html.replace(/<[^>]+>/g, "");
}

function calculateReadingTime(text: string, wpm: number): number {
  const words = text.trim().split(/\s+/).length;
  const minutes = words / wpm;

  return Math.ceil(minutes);
}

function calculateReadingTimeFromHtml(html: string): number {
  const wpm: number = 180;
  const text = stripHtml(html);
  return calculateReadingTime(text, wpm);
}

function pluralizeMinute(n: number): string {
  const abs = Math.abs(n) % 100;
  const lastDigit = abs % 10;

  if (abs > 10 && abs < 20) {
    return `${n} минут`;
  }
  if (lastDigit === 1) {
    return `${n} минута`;
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return `${n} минуты`;
  }
  return `${n} минут`;
}

export type ArticleMetaProps = {
  category: string | null;
  dateStr: string;
  lang: string;
  categoryId: string | null;
};

export const ArticleMeta = ({
  category,
  dateStr,
  lang,
  categoryId,
}: ArticleMetaProps) => {
  const [minutes, setMinutes] = useState<number | null>(null);

  useEffect(() => {
    const html = document.querySelector("#blog-article")?.innerHTML;

    setMinutes(html ? calculateReadingTimeFromHtml(html) : 0);
  }, []);

  return (
    <div className={styles["article-meta"]}>
      {category && categoryId && (
        <>
          <div>
            <Link href={`${getUrlLang(lang)}/blog?categoryId=${categoryId}`}>
              {category}
            </Link>
          </div>
          <div className={styles["dot"]} />
        </>
      )}
      <div>{dateStr}</div>
      {minutes && (
        <>
          <div className={styles["dot"]} />
          <div>{pluralizeMinute(minutes)}</div>
        </>
      )}
    </div>
  );
};
